<template>
  <div class="main-contain">
    <div class="module-title">
      <div class="main-title-text title-box pl10">
        历史数据统计分析(类型：{{ keyTypeMap[keyType] }} &nbsp;&nbsp; 时间：{{ dateOptions[dateType] }})
      </div>
    </div>
    <div class="chart-container">
      <div class="left">
        <div
          class="line"
          @click="showDialog"
        >
          <div class="legend-line">
            <legend-item
              :keyType="keyType"
              :machineNum="1"
            />
          </div>
          <sing-chart
            ref="pieChart1"
            style="width: 100%;"
            id="machineOne1"
          ></sing-chart>
          <div class="echart-title">1号机组</div>
        </div>
        <div
          class="line"
          @click="showDialog"
        >
          <div class="legend-line">
            <legend-item
              :keyType="keyType"
              :machineNum="2"
            />
          </div>
          <sing-chart
            ref="pieChart2"
            style="width: 100%;"
            id="machineThree3"
          ></sing-chart>
          <div class="echart-title">2号机组</div>
        </div>
      </div>
      <div class="right">

        <div
          class="line"
          @click="showDialog"
        >
          <div class="legend-line">
            <legend-item
              :keyType="keyType"
              :machineNum="3"
            />
          </div>
          <sing-chart
            ref="pieChart3"
            style="width: 100%;"
            id="machineTwo2"
          ></sing-chart>
          <div class="echart-title">3号机组</div>
        </div>
      </div>
    </div>
    <model-one-dialog
      title="历史数据统计分析"
      width="25%"
      ref="modelOneDialogRef"
      @refresh="getDataByParams"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import ModelOneDialog from './dialogComponents/ModelOneDialog.vue'
import SingChart from './echartComponents/SingPie.vue'
import legendItem from './legendItem.vue'

export default {
  components: { SingChart, ModelOneDialog, legendItem },
  data() {
    return {
      legendList: [
        { name1: '50以下', name2: '7以下', name3: '49.3-54.1', color: '#accfff' },
        { name1: '50-59', name2: '7-9.9', name3: '54.2-58.9', color: '#1871fe' },
        { name1: '60-69', name2: '10-12.9', name3: '59.0-63.7', color: '#18c5fe' },
        { name1: '70-79', name2: '13-15.9', name3: '63.8-67.3', color: '#44dd9e' },
        { name1: '80-89', name2: '16-18.9', name3: '67.4-69.7', color: '#fff22f' },
        { name1: '90及以上', name2: '19以上', name3: '69.8-73.3', color: '#f87c20' },
      ],
      keyType: 1,
      dateType: 1,
      dateOptions: {
        1: '日',
        2: '周',
        3: '月',
        4: '季',
        5: '年'
      },
      keyTypeMap: {
        1: '机组效率',
        2: '耗水率',
        3: 'F值',
        4: '有功功率',
        5: '无功功率',
        6: '工作水头'
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getDataByParams(params) {
      this.setTitle(params)
      this.getData()
    },
    showDialog() {
      this.$refs.modelOneDialogRef.show('ModelThreeDetail')
    },
    getData() {
      this.$http.get({ url: api.historyAnalysis }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.setData(dataList)
      })
    },
    setData(dataList) {
      this.$refs.pieChart1.initChart(dataList[0], this.keyType, 1)
      this.$refs.pieChart2.initChart(dataList[1], this.keyType, 2)
      this.$refs.pieChart3.initChart(dataList[2], this.keyType, 3)
    },
    setTitle(setting) {
      this.keyType = setting.historyAnalysisKeyType
      this.dateType = setting.historyAnalysisTimeType
    }
  }
}
</script>

<style scoped>
.handle-line /deep/ .el-range-editor--mini .el-range-input {
  background: #0c2341 !important;
  color: #fff;
}
.handle-line /deep/ .el-input--mini .el-input__inner {
  background: #0c2341 !important;
  border: 1px solid #1a4c89;
  color: #fff;
}
.handle-line .data-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
.handle-line .my-select {
  width: 130px !important;
  background-color: #0c2342 !important;
}
</style>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  .module-title {
    padding-top: 20px;
    height: calc(10% - 20px);
    width: 100%;
    .title-box {
      display: flex;
      // &:before {
      //   content: url('@/assets/img/arrow.png');
      //   width: 30px;
      //   height: 30px;
      //   left: 90px;
      // }
    }
    .handle-line {
      display: flex;
      .select-label {
        color: #fff;
        font-size: 14px;
        margin-left: 20px;
        line-height: 28px;
      }
    }
  }
  .chart-container {
    height: 89%;
    display: flex;
    .left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: -80px;
      .line {
        height: 35%;
        width: 100%;
        position: relative;
        .legend-line {
          position: absolute;
          right: 20px;
          top: 30%;
        }
        .echart-title {
          width: 80px;
          text-align: center;
          position: absolute;
          bottom: -10px;
          left: calc(50% - 40px);
          color: #fff;
          font-size: 18px;
        }
      }
    }
    .right {
      margin-left: -100px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .line {
        height: 35%;
        width: 100%;
        position: relative;
        .legend-line {
          position: absolute;
          right: 20px;
          top: 30%;
        }
        .echart-title {
          width: 80px;
          text-align: center;
          position: absolute;
          bottom: -10px;
          left: calc(50% - 40px);
          color: #fff;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
